<template>
    <section class="gh-section gh-summit-section" id="gh-purpose-section" style="background: #fff">
        <div class="container purpose-container">
            <el-row class="purpose-row">
                <el-col :xs="24" :md="24">
                    <p class="gh-center gh-section-heading gh-lightBlue">PURPOSE</p>
                    <p class="gh-center heading-1 gh-lightBlue purpose-content">To equip practicing mental health professionals with global best-practice knowledge and skills on suicide prevention, thereby making a tangible reduction on suicide rates.</p>
                </el-col>
            </el-row>

            <el-row :gutter="gutter">
                <el-col :xs="24" :md="12">
                    <p class="gh-text gh-darkgrey pb-1">Suicide remains one of the leading causes of death in the UK and Ireland, and one of the world’s most pressing health challenges. As a mental health professional, you are an essential piece in the continuum of care for suicidal people. <span class="gh-text gh-darkgrey gh-text-1 pb-1">You must be prepared.</span>
                    </p>
                    <p class="gh-text gh-darkgrey pb-1">Mental Health Academy (MHA) and the British Psychological Society (BPS) have partnered to bring you the 2022 Suicide Prevention Summit. The purpose of this Summit is to equip clinicians and peer support workers with the most up-to-date, advanced knowledge and treatment options on suicide prevention. To achieve that, we’ve assembled 10 highly respected experts on suicide into one online specialised Summit.</p>
                </el-col>

                <el-col :xs="24" :md="12">
                    <p class="gh-text gh-darkgrey pb-1">Over 2 days, September 10 & 11, you’ll enjoy real-time, interactive access to 10 webinars. You will then have on-demand streaming access to video recordings (see registration form below for further details). One of the most powerful resources we have to reduce suicide is our frontline mental health workforce. We believe that by providing mental health practitioners with global best-practice know-how and skills, we can tangibly reduce suicide rates.</p>
                    <p class="gh-text gh-darkgrey pb-1">We see our role as bringing global best-practice education to practitioners. Your role is taking the time to learn and apply. As we endeavour to save valuable lives, we look forward to seeing you at the online 2022 Suicide Prevention Summit.</p>
                </el-col>
            </el-row>
        </div>
    </section>
</template>

<script>
    import windowSizeMixin from '@/modules/events/suicidePreventionSummit/mixins/windowSize'
    import UX from '@/utils/ux';

    export default {
        mixins: [windowSizeMixin],

        computed: {
            gutter () {
                return this.windowWidth <= 1024 ? 0 : 50
            }
        },

        methods: {
            scrollToRegistrationForm() {
                UX.scrollTo(document.getElementById('registration'));
            }
        }
    }
</script>

<style scoped lang="scss">
    #gh-purpose-section {
        padding-bottom: 0;
    }

    .heading-1 {
        font-size: 1.4rem;
        line-height: 1.2;
        margin-bottom: 20px;
    }

    .purpose-row {
        margin-bottom:50px;
        @media (max-width: 767px) {
            margin-bottom: 0;
        }
    }

    .purpose-content {
        font-size: 1.8rem;
        font-weight: 500;
        max-width: 1110px;
        margin: auto;
        font-family: proxima-nova,sans-serif;
        @media (max-width: 767px) {
            font-size: 1.4rem;
        }

        @media (max-width: 480px) {
          margin-bottom: 2rem;
        }
    }

    .gh-text {
        font-size: 1.2rem;
        font-family: proxima-nova,sans-serif !important;
        margin-bottom: 15px;
        line-height: 1.3;
    }
    .gh-text-1 {
        font-family: proxima-nova,sans-serif !important;
        font-weight: bold !important;
        //font-size: 1.35rem;
    }

    a {
        cursor: pointer;
        text-decoration: underline;
    }
</style>
